"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_PUBLIC_CODE_RE = void 0;
/**
 * Regex that matches every post public code produced by Post::setPublicCodeAttribute.
 *
 * The backend method uses sprintf('%05d', $value), which pads to *at least*
 * five digits but does not cap length — a post ID ≥ 100 000 yields a
 * six-or-more-character suffix (e.g. B123456).  The quantifier is therefore
 * `\d{5,}` (five-or-more) rather than the exact `\d{5}`.
 *
 * Character class mirrors the property types currently defined in
 * Post::setPublicCodeAttribute:
 *   B = apartment, C = commercial, H = house, L = land
 *
 * IMPORTANT: if a new property type is added on the backend with a different
 * prefix letter, add that letter to this character class too — otherwise
 * map-pin clicks on those posts will silently fail to open the post modal.
 */
exports.POST_PUBLIC_CODE_RE = /[BCHL]\d{5,}$/; // 5-or-more digits; keep in sync with Post::setPublicCodeAttribute
